(function() {
    const teamMembers = document.querySelectorAll('.js-team-members');

    const init = teamMember => {
        const tabList = teamMember.querySelector('.js-team-members-tabs');

        /**
         * Get all tabs in the block.
         */
        const tabs = Array.from(tabList.children);

        /**
         * Create a random starting index.
         */
        let tabIndex = Math.floor(Math.random() * tabList.childElementCount);

        /**
         * Map instance to store the connections between tabs and panels.
         */
        const connections = new Map();

        /**
         * Loops over each tabs and panels.
         * Set the aria-selected and hidden attributes based on if its the clicked tab or not.
         * @param {HTMLElement} clickedTab
         * @returns {void}
         */
         const toggleTabsAndpanels = (clickedTab) => {
            for (const [tab, panel] of connections) {
                if (tab !== clickedTab) {
                    tab.setAttribute('aria-selected', false);
                    panel.setAttribute('tabindex', '-1');
                    panel.hidden = true;
                } else {
                    tab.setAttribute('aria-selected', true);
                    panel.setAttribute('tabindex', '0');
                    panel.hidden = false;
                }
            }
        };

        /**
         * Gets the tab from the tabs array and passes it to the toggleTabsAndPanels function.
         * @uses toggleTabsAndpanels
         * @param {number} index 
         * @returns {void}
         */
        const toggleTabByIndex = index => {
            const tab = tabs[index];
            toggleTabsAndpanels(tab);
        };

        /**
         * Goes to the next tab.
         * When the end is reached it restarts at 0.
         * @uses toggleTabByIndex
         */
        const nextTab = () => {
            if (tabIndex + 1 < tabs.length) {
                tabIndex++;
            } else {
                tabIndex = 0;
            }

            toggleTabByIndex(tabIndex);
        };

        /**
         * Starts an interval that calls nextTab every 5 seconds and returns the interval id.
         * @returns {number}
         */
        const startLoop = () => setInterval(nextTab, 5000);

        /**
         * Start looping.
         */
        let interval = startLoop();

        /**
         * Stops the loop on a hover state.
         * @returns {void}
         */
        const onTabMouseEnter = () => {
            clearInterval(interval);
        };

        /**
         * Restarts the loop when hovering has stopped.
         * @returns {void}
         */
        const onTabMouseLeave = () => {
            interval = startLoop();
        };

        /**
         * Loop over the tabs and get the aria-controls attribute value.
         * Use that value to get the panel asssociated to the tab and store it in the map.
         */
        for (const tab of tabs) {
            const ariaControls = tab.getAttribute('aria-controls');
            const panel = teamMember.querySelector(`#${ariaControls}`);

            if (panel) {
                connections.set(tab, panel);
            }

            tab.addEventListener('mouseenter', onTabMouseEnter);
            tab.addEventListener('mouseleave', onTabMouseLeave);
        }

        /**
         * Get the clicked tab and toggle the tabs and panels.
         * @param {Event} event
         * @param {EventTarget} event.target
         * @returns {void}
         */
        const onTabClick = ({ target }) => {
            const tab = target.closest('.js-team-members-tab');
            if (!tab || !connections.has(tab)) {
                return;
            }

            /**
             * Set the index based on the tab position.
             */
            tabIndex = tabs.indexOf(tab);

            /**
             * Toggle the tabs and panels.
             */
            toggleTabsAndpanels(tab);
        };

        teamMember.addEventListener('click', onTabClick);
    };

    teamMembers.forEach(init);
}());


// WEBPACK FOOTER //
// ./scripts/custom/team-members.js